"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Countdown = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_jss_1 = require("react-jss");
var Contexts_1 = require("../Contexts");
var Ioc_1 = require("../utilities/Ioc");
var CountdownProvider_1 = require("./CountdownProvider");
var pad = function (num) {
    return num < 10 ? "0".concat(num) : "".concat(num);
};
var useCountdownStyles = (0, react_jss_1.createUseStyles)(function (theme) { return ({
    container: {
        fontSize: "28px",
        display: "flex",
        lineHeight: 1,
    },
    valueContainer: {
        display: "flex",
        padding: "2px",
        color: theme.colors.baseContrast070,
    },
    // TODO: Things look a little funky when the left digit is a 1.
    // We may want to have a left and right digit that align their content
    // towards the opposite side that they are. So left digit would align right.
    // Maybe using a monospaced font would solve this?
    digit: {
        width: "16px",
        paddingInlineStart: "1px",
    },
    label: {
        fontSize: "10px",
        color: theme.colors.baseContrast050,
        textTransform: "uppercase",
    },
    partContainer: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "center",
        width: "38px",
        margin: "0 2px",
    },
    separator: {
        color: theme.colors.baseContrast050,
        "&::after": {
            content: '"|"',
        },
    },
}); });
var Value = function (_a) {
    var value = _a.value;
    var classes = useCountdownStyles();
    return ((0, jsx_runtime_1.jsx)("div", { className: classes.valueContainer, children: pad(value)
            .split("")
            .map(function (d, i) { return ((0, jsx_runtime_1.jsx)("div", { className: classes.digit, children: d }, "digit-".concat(i))); }) }));
};
var Part = function (_a) {
    var label = _a.label, value = _a.value;
    var classes = useCountdownStyles();
    return ((0, jsx_runtime_1.jsxs)("div", { className: classes.partContainer, children: [(0, jsx_runtime_1.jsx)(Value, { value: value }), (0, jsx_runtime_1.jsx)("div", { className: classes.label, children: label })] }));
};
var Countdown = function (_a) {
    var initialTimeRemaining = _a.initialTimeRemaining;
    var classes = useCountdownStyles();
    var _b = __read((0, Ioc_1.useContexts)(Contexts_1.ITranslationServiceContext), 1), translate = _b[0].translate;
    return ((0, jsx_runtime_1.jsx)(CountdownProvider_1.CountdownProvider, { initialTimeRemaining: initialTimeRemaining, interval: 211, children: function (_a) {
            var days = _a.days, hours = _a.hours, minutes = _a.minutes, seconds = _a.seconds;
            return ((0, jsx_runtime_1.jsxs)("div", { className: classes.container, children: [(0, jsx_runtime_1.jsx)(Part, { value: days, label: translate("time.days_abbr") }), (0, jsx_runtime_1.jsx)("span", { className: classes.separator }), (0, jsx_runtime_1.jsx)(Part, { value: hours, label: translate("time.hours_abbr") }), (0, jsx_runtime_1.jsx)("span", { className: classes.separator }), (0, jsx_runtime_1.jsx)(Part, { value: minutes, label: translate("time.minutes_abbr") }), (0, jsx_runtime_1.jsx)("span", { className: classes.separator }), (0, jsx_runtime_1.jsx)(Part, { value: seconds, label: translate("time.seconds_abbr") })] }));
        } }));
};
exports.Countdown = Countdown;
exports.Countdown.displayName = "Countdown";
//# sourceMappingURL=Countdown.js.map